// extracted by mini-css-extract-plugin
export default {"statusContainer":"Status_statusContainer__TudQ8","checkCommentsButton":"Status_checkCommentsButton__K5qFm","commentsContainer":"Status_commentsContainer__+t8OP"};